import {Component} from 'react'

import './index.css'

class Stopwatch extends Component {
  state = {
    isRunning: false,
    timerSeconds: 0,
  }

  componentWillUnmount() {
    this.clearTimerInterval()
  }

  clearTimerInterval = () => {
    clearInterval(this.timerId)
  }

  updateTimer = () => {
    this.setState(prevState => ({
      timerSeconds: prevState.timerSeconds + 1,
    }))
  }

  onClickStart = () => {
    const {isRunning} = this.state

    if (isRunning) {
      return null
    }
    this.setState({isRunning: true})
    this.timerId = setInterval(this.updateTimer, 1000)
    return null
  }

  onClickStop = () => {
    this.clearTimerInterval()
    this.setState({isRunning: false})
  }

  onClickReset = () => {
    this.clearTimerInterval()
    this.setState({
      timerSeconds: 0,
      isRunning: false,
    })
  }

  timeFormat = () => {
    const {timerSeconds} = this.state
    const minutes = Math.floor(timerSeconds / 60)
    const seconds = Math.floor(timerSeconds % 60)

    const stringifyMinutes = minutes > 9 ? minutes : `0${minutes}`
    const stringifySeconds = seconds > 9 ? seconds : `0${seconds}`

    return `${stringifyMinutes}:${stringifySeconds}`
  }

  render() {
    return (
      <div className="bg">
        <div className="stopwatch-cont">
          <h1>Stopwatch</h1>
          <div className="card">
            <div className="mini">
              <img
                src="https://assets.ccbp.in/frontend/react-js/stopwatch-timer.png"
                alt="stopwatch"
              />
              <p>Timer</p>
            </div>
            <h1 className="time">{this.timeFormat()}</h1>
            <div className="buttons">
              <button
                onClick={this.onClickStart}
                type="button"
                className="start-btn"
              >
                Start
              </button>
              <button
                onClick={this.onClickStop}
                type="button"
                className="stop-btn"
              >
                Stop
              </button>
              <button
                type="button"
                onClick={this.onClickReset}
                className="reset-btn"
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default Stopwatch
